import { gql } from '@apollo/client';

export default gql`
  mutation OriginalPaymentMarket($bookingReference: String!, $paymentMethod: String!, $paymentReference: String!) {
    originalPaymentMarket(bookingReference: $bookingReference, paymentMethod: $paymentMethod, paymentReference: $paymentReference)
  }
`;
